import { type AssetTransformationTask } from '~/store/tasks/types';
import { type VideoClipTask } from './types';

/**
 * Type predicate to narrow AssetTransformationTask to VideoClipTask.
 */
export const isVideoClipTask = (task: AssetTransformationTask): task is VideoClipTask => {
  return task.metadata.transformType === 'clipVideo';
};
